import { render, staticRenderFns } from "./procurementWhite.vue?vue&type=template&id=5eaf1704&scoped=true"
import script from "./procurementWhite.vue?vue&type=script&lang=js"
export * from "./procurementWhite.vue?vue&type=script&lang=js"
import style0 from "./procurementWhite.vue?vue&type=style&index=0&id=5eaf1704&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaf1704",
  null
  
)

export default component.exports